module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 480\" version=\"1\"><g fill-rule=\"evenodd\"><path fill=\"#fff\" d=\"M640 480H0V0h640z\"/><path fill=\"#df0000\" d=\"M640 480H0V319.997h640zm0-319.875H0V.122h640z\"/></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/flag/at.svg
// module id = 46
// module chunks = 0